var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2048v2048H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M255.999 255.999h1536v1536h-1536z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "m1303.19 255.999 328.759 329.158h-269.982c-32.328 0-58.776-26.448-58.776-58.776V255.999z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc80",
    d: "M454.851 255.999h848.395v268.747c0 33.228 27.184 60.411 60.411 60.411h268.344V1400c0 22-17.999 40-40 40H454.852c-22 0-39.998-18-39.998-40V296c0-22 17.999-40 39.999-40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    fillRule: "nonzero",
    d: "M671.999 755.343H1408v64.001H671.999zM671.999 979.338H1408v64.002H671.999z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    d: "M337.396 1218.19h1373.21c22.375 0 42.735 9.234 57.51 24.108 14.738 14.835 23.887 35.238 23.887 57.618v394.353c0 22.381-9.15 42.782-23.887 57.618-14.777 14.874-35.136 24.109-57.51 24.109H337.396c-22.373 0-42.735-9.235-57.512-24.109-14.736-14.833-23.885-35.234-23.885-57.618v-394.353c0-22.381 9.149-42.783 23.885-57.618 14.775-14.874 35.137-24.108 57.512-24.108z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "m550 1676.06 122.333-186.75-110.832-171.167h84.416l71.833 115 70.251-115h83.75l-111.333 173.834L882.75 1676.06h-87.167l-79.333-123.75-79.583 123.75H550zm371.834 0v-354.999h72.25v294.666h179.666v60.333H921.834zm285.167-116.417 70.332-6.917c4.167 23.667 12.75 41 25.75 52.084 12.917 11 30.334 16.583 52.334 16.583 23.25 0 40.833-4.916 52.583-14.833 11.833-9.834 17.75-21.333 17.75-34.5 0-8.5-2.5-15.667-7.5-21.584-4.916-6-13.583-11.167-26-15.5-8.417-3-27.75-8.166-57.833-15.666-38.75-9.584-65.916-21.417-81.5-35.417-22-19.667-33-43.667-33-72 0-18.25 5.167-35.25 15.5-51.167 10.334-15.834 25.25-27.916 44.667-36.25 19.5-8.25 42.917-12.416 70.416-12.416 45 0 78.75 9.833 101.5 29.5 22.667 19.75 34.583 46 35.75 78.916l-72.25 3.166c-3.083-18.415-9.75-31.666-19.916-39.666-10.167-8.083-25.418-12.084-45.75-12.084-21 0-37.5 4.251-49.334 12.918-7.666 5.5-11.5 12.916-11.5 22.166 0 8.5 3.583 15.75 10.75 21.75 9.083 7.666 31.25 15.667 66.417 23.917 35.166 8.333 61.166 16.916 78 25.75 16.833 8.917 30 21 39.583 36.416 9.5 15.417 14.25 34.418 14.25 57 0 20.5-5.666 39.75-17.084 57.584-11.416 17.916-27.5 31.25-48.333 39.916-20.834 8.75-46.833 13.083-77.916 13.083-45.25 0-80-10.416-104.25-31.333-24.25-20.916-38.75-51.416-43.416-91.416z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.6351c89b8d9859ca538cc76c8e8e503b.svg";
export { ForwardRef as ReactComponent };